const window = require('window');
const Backbone = require('backbone');
const dustjs = require('dustjs');
const { LIVE_AGENT_POPUP_TYPE } = require('lib/enums');
const omnitureHelper = require('app/views/store/common/omniture/omniture_helper');
const LiveAgentCustomPopupView = Backbone.View.extend({
	initialize: function(options = {}) {
		this.options = options;
		if (!this._isLiveAgentFullyRendered()) {
			this._renderPopup();
		}
	},
	_isLiveAgentChatSessionActive: function() {
		return !$('.dockableContainer .inputEmail .uiInputEmail').length;
	},
	_isLiveAgentFullyRendered: function() {
		return Boolean($('.sidebarHeader').length);
	},
	_renderPopup: function _renderPopup() {
		// check if snap-in has fully rendered
		if (this._isLiveAgentFullyRendered()) {
			dustjs.render(this.options.template, {}, this._appendPopup.bind(this));
			if (this.options.type === LIVE_AGENT_POPUP_TYPE.PROACTIVE) {
				Backbone.trigger(
					'omniture:chatTracking',
					`livechatproactiveinvited~${omnitureHelper._chatTrackingMessage(
						window.s.pageName,
						window.dataLayer.baseCategory,
						omnitureHelper._getBusinessCategory()
					)}`,
					'proactiveinvited',
					window.s.pageName,
					window.dataLayer.baseCategory,
					omnitureHelper._getBusinessCategory()
				);
			} else {
				window.dataLayer.liveAgentOffline = true;
			}
		} else {
			setTimeout(_renderPopup.bind(this), 100);
		}
	},
	_appendPopup: function(err, data) {
		if (this._isLiveAgentChatSessionActive()) {
			return;
		}
		const $dockableContainer = $('.dockableContainer');
		// for header chat click, sidebar may not be maximized yet
		this._forceMaximizeSidebar($dockableContainer);

		$dockableContainer.find('.prechatUI').addClass('proactive-body');
		$dockableContainer.find('.embeddedServiceSidebarState').append(data);

		this._hideGeneralChat($dockableContainer);
	},
	_forceMaximizeSidebar($dockableContainer) {
		const $sidebarContainer = $dockableContainer.closest('.embeddedServiceSidebar');
		if ($sidebarContainer.hasClass('sidebarMinimized')) {
			$sidebarContainer.removeClass('sidebarMinimized');
			$sidebarContainer.addClass('sidebarMaximized');
		}
	},
	_hideGeneralChat: function($theChatContainer) {
		$theChatContainer.find('.js-desktop-start-chatting-button').on('click', function() {
			$theChatContainer.find('.embeddedServiceLiveAgentStateChat').remove();
			$theChatContainer.find('.prechatUI').removeClass('proactive-body');
		});
	}
});
module.exports = LiveAgentCustomPopupView;
